import { setCookie } from "@smile2impress/attraction-utils";

import { COOKIES } from "constants/enum";
import { getAppMode } from "utils/getAppMode";

export const MONTH_IN_MS = 1000 * 60 * 60 * 24 * 30;

export const saveExpToCookies = (expId: string, varId: string) => {
    const currentTime = new Date().getTime();
    const { isLiveMode } = getAppMode();

    const newExperimentData = {
        id: String(expId),
        group: String(varId),
        expires: currentTime + MONTH_IN_MS,
    };

    setCookie(
        COOKIES.IMPRESS_AB_EXPERIMENT,
        JSON.stringify(newExperimentData),
        {
            path: "/",
            "max-age": currentTime + MONTH_IN_MS,
            ...(isLiveMode && { domain: ".smile2impress.com" }),
        }
    );
};
